<div class="mat-elevation-z8"
     [ngClass]="!option.pagination ? 'table-scroll' : '' "
>
  <table mat-table matSort  [dataSource]="dataSource">
    <div class="columns" *ngFor="let col of cols; index as i">
      <input type="hidden" value="{{i+1}}">
      <ng-container matColumnDef="{{col.id}}">

        <div *ngIf="option.sort">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center" >
            <a *ngIf="col.action.nestedCol"
               (click)="addNestedColumns(col)"
            >
              {{col.name}}
            </a>
            <span *ngIf="col.action.nestedCol == null">
              {{col.name}}
            </span>
          </th>
        </div>

        <div *ngIf="!option.sort">
          <th mat-header-cell *matHeaderCellDef >
            <a class="not-link" *ngIf="col.action.nestedCol"
               (click)="addNestedColumns(col)"
            >
              {{col.name}}
            </a>
            <span *ngIf="col.action.nestedCol == null">
            {{col.name}}
            </span>
          </th>
        </div>

        <td *ngIf="dataSource.data.length == 0">

        </td>

        <div *ngIf="dataSource.data.length > 0" >

          <!-- Row con parent -->
          <div  *ngIf="col.parent">
            <td class="nested-column" mat-cell *matCellDef="let element">
              <div ngSwitch="{{col.type}}" >
                <div class="element"  *ngSwitchCase="'date'">
                  {{element[col.key] | date: 'yyyy-MM-dd'}}
                </div>
                <div class="element"  *ngSwitchCase="'number'">
                  {{element[col.key]}}
                </div>
                <div class="element" *ngSwitchCase="'currency'">
                  {{element[col.key] | currency}}
                </div>
                <div class="element" *ngSwitchCase="'string'">
                  <a *ngIf="col.action.activated && (col.action.link && !col.action.href)"
                     routerLink="{{col.action.link}}/{{element[col.key]}}">
                    {{element[col.key]}}
                  </a>
                  <a *ngIf="col.action.activated &&( col.action.href && !col.action.link)"
                     href="{{col.action.href}}" >
                    {{element[col.key]}}
                  </a>
                  <span *ngIf="!col.action.activated">
                    {{element[col.key]}}
                  </span>
                </div>
                <div class="element"  *ngSwitchCase="'button'">
                  <div *ngIf=" col.action.nestedCol && col.action.nestedCol.length > 0">
                    <div class="buttons" *ngFor="let button of col.action.nestedCol">
                      <button class="col-type-button" (click)="buttonSelected(element)" mat-raised-button color="primary">{{button.key}}</button>
                    </div>
                  </div>
                  <div *ngIf="!col.action.nestedCol">
                    <button class="col-type-button" (click)="buttonSelected(element)" mat-raised-button color="primary">{{col.key}}</button>
                  </div>
                </div>
              </div>
            </td>
          </div>


          <!-- Row simple -->
          <div  *ngIf="!col.parent" >
            <!-- Row string,currency, number, link -->
            <div *ngIf="col.type != 'button'">
              <td class="simple-column" mat-cell
                  [ngStyle]="{ 'padding': col.padding, 'text-align': col.align }"
                  *matCellDef="let element;"
                  (click)="selectItem(element, $event)"
              >
                <mat-icon *ngIf="element.checked && i == 0" class="icon-checked">done</mat-icon>
                <div ngSwitch="{{col.type}}">
                  <div class="element" style="min-width: max-content;" *ngSwitchCase="'date'">
                    {{element[col.key] | date: 'yyyy-MM-dd'}}
                  </div>
                  <div class="element"  *ngSwitchCase="'number'">
                    {{element[col.key]}}
                  </div>
                  <div class="element"  *ngSwitchCase="'currency'">
                    {{element[col.key] | currency}}
                  </div>
                  <div class="element" *ngSwitchCase="'string'">
                    <a *ngIf="col.action.activated && (col.action.link && !col.action.href)"
                       routerLink="{{col.action.link}}/{{element[col.key]}}" >
                      {{element[col.key]}}
                    </a>
                    <a *ngIf="col.action.activated &&( col.action.href && !col.action.link)"
                       href="{{col.action.href}}" >
                      {{element[col.key]}}
                    </a>
                    <span *ngIf="!col.action.activated" [style.padding-left]="col.key === 'contract_number' ? '30px' : ''">
                      {{element[col.key]}}
                    </span>
                  </div>
                  <div class="element" *ngSwitchCase="'custom_string'">
                    <span [ngStyle]="{ 'color':(col.action.style && element[col.key] <= 10 && element['status'] != 'Repagado') ? col.action.textColor : 'green' }">
                      {{element[col.key]}}
                    </span>
                  </div>
                  <div class="element"  *ngSwitchCase="'textbox'">
                    <input  type="text"
                            value="{{element[col.key]}}"
                            class="form-control"
                            style="width:9em"
                            (change)="onChangeItem($event,element,col.key)">
                  </div>
                  <div class="element"  *ngSwitchCase="'datebox'">
                    <input  type="date"
                            value="{{element[col.key]}}"
                            class="form-control"
                            style="width:10.3em"
                            (change)="onChangeItem($event,element,col.key)">
                  </div>
                </div>
              </td>
            </div>

            <!-- Row button -->
            <div *ngIf="col.type == 'button'">
              <td class="simple-column" mat-cell
                  *matCellDef="let element;"
              >
                <div class="element">
                  <!-- Multiples botones -->
                  <div *ngIf=" col.action.nestedCol && col.action.nestedCol.length > 0">
                    <div class="buttons" >
                      <div class="col-type-button" *ngFor="let button of col.action.nestedCol"
                              [class]="button.label"
                              (click)="buttonSelected(element, button.key)"
                              mat-raised-button color="primary">
                        <!-- Icono -->
                        <div *ngIf="!button.icon">
                          {{button.name}}
                        </div>
                        <!-- Texto -->
                        <div *ngIf="button.icon">
                          <mat-icon >{{button.icon}}</mat-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Boton solo -->
                  <div *ngIf="!col.action.nestedCol">
                    <button *ngIf="!col.icon" class="col-type-button" (click)="buttonSelected(element)" mat-raised-button color="warn">{{col.key}}</button>
                    <mat-icon *ngIf="col.icon">{{col.icon}}</mat-icon>
                  </div>
                </div>
              </td>
            </div>
          </div>

        </div>
      </ng-container>
    </div>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <div *ngIf="!option.eventClick">
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </div>

    <div *ngIf="option.eventClick">
      <tr mat-row (click)="onSelectionRow(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </div>
    

  </table>
  <div *ngIf="option.pagination">

    <!--Server side-->
    <div *ngIf="!paginate.isFake">
      <mat-paginator
        [pageSizeOptions]="paginate.sizeOption"
        [length]="paginate.totalItems"
        (page)="pageEvent = $event; onPaginateChange($event)"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>

    <!--Front Side-->
    <div *ngIf="paginate.isFake" >
      <mat-paginator  [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>

  </div>
</div>
